export default __webpack_public_path__ + "static/media/brand-pattern.936ce9f7.svg";